import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [ "locale" ]

  connect(){
  }

  changeLocale(){
    var url = this.URL_add_parameter(window.location.href, 'locale', this.localeTarget.value)
    window.location.href = url;
  }

  // changes the locale of the current path no with params but with the locale in the path
  // given current path like /es/blog, redirect to /en/blog
  // given current path like /blog, redirect to /en/blog
  // given current path like /es/blog/1234567890, redirect to /en/blog/1234567890
  // given current path like /blog/1234567890, redirect to /en/blog/1234567890
  changePathLocale() {
    const newLocale = this.localeTarget?.value
    if (!newLocale) { return }

    const { pathname, origin, search, hash } = window.location
    const segments = pathname.split("/").filter(Boolean)

    // Determine if current path is for blog and extract the path after "blog"
    let rest = []
    const localePattern = /^(en|es|pt)(-[A-Za-z0-9]+)?$/ // soporta en, es, pt y variantes tipo en-US si aparecieran

    if (segments[0] === "blog") {
      // Could be /blog, /blog/:locale, or /blog/:locale/...
      if (segments[1] && localePattern.test(segments[1])) {
        // Remove existing locale after blog
        rest = segments.slice(2)
      } else {
        // No locale currently in path; keep the remaining as rest
        rest = segments.slice(1)
      }
    } else if (segments[0] && localePattern.test(segments[0]) && segments[1] === "blog") {
      // Legacy /:locale/blog/... -> strip the leading locale
      rest = segments.slice(2)
    } else {
      // Not a blog path; fall back to query-param locale change
      const url = this.URL_add_parameter(window.location.href, 'locale', newLocale)
      window.location.href = url
      return
    }

    const newPath = `/blog/${newLocale}` + (rest.length ? `/${rest.join("/")}` : "")

    // Remove any existing locale query param to avoid conflicts with new path-locale
    let cleanQuery = ""
    if (search && search.length > 1) {
      const params = new URLSearchParams(search)
      params.delete("locale")
      const qs = params.toString()
      cleanQuery = qs ? `?${qs}` : ""
    }

    const newUrl = origin + newPath + cleanQuery + (hash || "")
    window.location.href = newUrl
  }

  URL_add_parameter(url, param, value){
    var hash       = {};
    var parser     = document.createElement('a');

    parser.href    = url;

    var parameters = parser.search.split(/\?|&/);

    for(var i=0; i < parameters.length; i++) {
        if(!parameters[i])
            continue;

        var ary      = parameters[i].split('=');
        hash[ary[0]] = ary[1];
    }

    hash[param] = value;

    var list = [];  
    Object.keys(hash).forEach(function (key) {
        list.push(key + '=' + hash[key]);
    });

    parser.search = '?' + list.join('&');
    return parser.href;
  }
} 
